import React, { useEffect, useState, }  from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { GetUrl, GetMaintenanceUrl, CTicksToDateString } from '../Utility.js';
import { useNavigate } from 'react-router-dom';

function DetailModalType2({ isOpen, No, onClose}) {
    const state = useSelector((state)=>state);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [Title, setTitle] = useState("");
    const [Text, setText] = useState("");
    const [Answer, setAnswer] = useState("");
    const [Time, setTime] = useState("");
    const [ID, setID] = useState("");

    const [First, setFirst] = useState(true);

    const Close = () =>{
        onClose();
        setFirst(true);
    }

    const RequestQA = async (index) => 
    {
        try
        {
            if(state.Request === 1)
            {
                return;
            }

            var secretkey = sessionStorage.getItem("secret_key");
            if(secretkey === null)
            {
                alert('유저 정보 만료(다시 로그인 해주세요)');  
                navigate('/login'); // 로그인 성공 시 메인 페이지로 이동  
                return;    
            } 
            
            dispatch({type:'Request'});
            const response = await fetch(GetUrl() + 'Admin/AdminGetQA', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ secret_key : secretkey, no : index}),
            });

            if (response.ok) {
                const data = await response.json();
                if(data.result === 0)
                {
                    setTitle(data.title);
                    setText(data.text);
                    setTime(CTicksToDateString(data.create_at_time));
                    setAnswer(data.answer);
                    setID(data.id);
                }
                else if(data.result === 14 ||
                        data.result === 16)
                {
                    alert('존재 하지 않는 티켓 입니다');  
                }
                else if(data.result === 15)
                {
                    alert('이미 사용한 티켓 입니다');  
                }
                else if(data.result === 3 ||
                        data.result === 1)
                {
                    alert('유저 정보 만료(다시 로그인 해주세요)');  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
                else if(data.result === 21) // 점검 중
                {
                    var startTime = CTicksToDateString(data.start_time);
                    var endTime = CTicksToDateString(data.end_time);
    
                    var message = `${startTime} ~ ${endTime} 점검 중 입니다. 잠시후에 이용해 주세요`;
                    alert(message);  
                    navigate('/login'); // 로그인 성공 시 메인 페이지로 이동
                }
            } 
            else
            {
                alert('Network Fail');
            }

            dispatch({type:'Response'});
        }
        catch(error)
        {
            alert('Network Fail');
            dispatch({type:'Response'});
            console.error(error);
        }
    };    

    if (!isOpen) return null;

    if(First === true)
    {
        setFirst(false);
        setTitle("");
        setText("");
        setTime("");
        setAnswer("");
        setID("");

        RequestQA(No);
    }

    return (
        <div className="detail-modal-type-2-overlay" onClick={Close}>
            <div className='detail-modal-type-2-container' onClick={(e) => e.stopPropagation()}>
                <div class="detail-modal-type-2-header">
                    <div class="title">{Title}</div>
                    <div class="info">
                        <span>작성자: {ID}</span>
                        <span>작성일: {Time}</span>
                        <button class="close-btn" onClick={Close}>닫기</button>
                    </div>
                </div>
                <div class="detail-modal-type-2-content">
                    <div class="detail-modal-type-2-label">Q:</div>
                    <div class="detail-modal-type-2-question-box">{Text}</div>
                    <div class="detail-modal-type-2-label">A:</div>
                    <div class="detail-modal-type-2-answer-box">{Answer}</div>
                </div>
            </div>
        </div>
    );
}

export default DetailModalType2;